import { AfterViewInit, Component, Injector, OnInit, ViewChild } from '@angular/core';
import { Observable } from "rxjs";
import { GeozoneViewModel } from "../Model/GeozoneViewModel";
import { ZoneService } from "../../../../services/zones.service";
import { GroupBaseAdminPanelComponent } from "../../base-admin-panel/group-base-admin-panel.component";
import { IManagableObject } from "../../IManagableObject";
import { map } from "rxjs/operators";
import { MapObject, SimpleMapComponent, MapPoint } from "../../../shared/components/simple-map/c.component";
import { IconViewModel } from "../../../../models/IconViewModel";
import { CreateGeozoneDialogComponent } from '../create-geozone-dialog/create-geozone-dialog.component';

declare const $;

@Component({
  selector: '[app-geozone]',
  templateUrl: './geozone.component.html',
  styleUrls: ['./geozone.component.css'],
  standalone: false
})
export class GeozoneComponent extends GroupBaseAdminPanelComponent implements OnInit, AfterViewInit {

  @ViewChild(SimpleMapComponent, { static: true }) map: SimpleMapComponent;

  private zonesService: ZoneService;
  public Icons: IconViewModel[] = [];
  public isEdit: boolean = false;
  public selectedGeozone: GeozoneViewModel;


  constructor(protected injector: Injector) {
    super(injector);
    this.zonesService = injector.get(ZoneService);
    this.groupName = "GeozonesGroup";
    this.entityName = "Geozone";
  }

  ngOnInit() {
    super.ngOnInit();

    this.zonesService.GetZoneIcons()
      .subscribe(icons => {
        this.Icons = icons;

        let blank = new IconViewModel();
        blank.Url = "/assets/icons/blank.svg";
        this.Icons.splice(0, 0, blank);
      });
  }
  ngAfterViewInit() {
    super.ngAfterViewInit();
    this.onResize();
  }

  public onDrawFinish(points) {
    this.selectedGeozone.Points = points.map(p => p.lat.toFixed(5) + " " + p.lng.toFixed(5)).join(" ");
  }

  protected Refresh() {
    this.zonesService.GetZones()
      .subscribe(zones => {
        this.objects = zones;
        //if (this.objects.length > 1000)
        //this.objects.length = 1000;
      });
    this.zonesService.GetGroups().subscribe(groups => {
      this.groupFilter.groups = groups;
    });
  }

  public onZoneChanged() {
    var points = new Array<MapPoint>();
    var arr = this.selectedGeozone.Points.split(" ");

    for (var i = 0; i < Math.floor(arr.length / 2); i++)
      points.push(new MapPoint(parseFloat(arr[2 * i]), parseFloat(arr[2 * i + 1])));

    var obj = new MapObject();
    obj.label = this.selectedGeozone.Name;
    obj.points = points;
    obj.style = this.selectedGeozone.Style.Clone();

    obj.icon = "";
    for (let i = 0; i < this.Icons.length; i++)
      if (this.selectedGeozone.IconId == this.Icons[i].Id)
        obj.icon = this.Icons[i].Url;
    obj.modify = true;
    this.map.ShowObjects([obj], false);
  }

  public onGeozoneSelected(geozone: GeozoneViewModel) {
    var obj = new MapObject();
    obj.geozoneId = geozone.Id;
    this.map.ShowObjects([obj], true);

    this.selectedGeozone = geozone;
  }

  protected doDeleteObject(id: number): Observable<any> {
    return this.zonesService.DeleteZone(id);
  }

  public createZone() {
    this.editZone(new GeozoneViewModel());
  }
  
  public editZone(geozone: GeozoneViewModel) {
    this.isEdit = geozone ? true : false;

    if (this.isEdit)
      this.map.HideObjectsLayer();
    else
      this.map.ShowObjectsLayer();

    if (geozone) {
      this.onGeozoneSelected(geozone);
      this.onZoneChanged();
    }
    else
      this.map.ShowObjects([], false);
  }

  protected doCreateGroup(input: IManagableObject): Observable<any> {
    return this.zonesService.CreateGroup(input);
  }

  protected doDeleteGroup(input: IManagableObject): Observable<any> {
    return this.zonesService.DeleteGroup(input);
  }

  public onSplitter(): void {
    var thisObj = this;
    $(document).bind("mousemove", function (e: any) {
      document.getSelection().removeAllRanges();
      var docW = $('.geozona-wrap').width();
      var pos = e.clientX - $('.geozona-wrap').offset().left;
      if (pos > 350 && pos < (docW - 350)) {
        $('.geozona-table').css({ 'flex-basis': pos + 'px', 'max-width': pos + 'px' });
        $('.geozona-map').css({ 'flex-basis': (docW - pos - 10) + 'px', 'max-width': (docW - pos - 10) + 'px' });
        thisObj.onResize();
      }
    });

    $(document).on("mouseup", function (e) {
      $(document).off("mousemove");
      $(document).off("mouseup");
    });
  }

  public onResize(): void {
    //$(window).trigger('resize');
  }

  Incomingfile(file) {
    if (!file) return;
    this.zonesService.Import(file)
      .subscribe((res) => {
        this.toastr.success(this.translate.instant("Import successful"));
        this.Refresh();
        this.syncService.NotifyEntityChanged(this.entityName, "");
      }, (err) => {
        this.toastr.error(this.translate.instant("Import failed"));
      });
  }

  OpenExport() {
    this.zonesService.export(this.objects.filter(c => c.IsChecked).map(o => o.Id))
      .pipe(map(res => {
        return {
          filename: 'export.kml',
          data: res
        };
      }))
      .subscribe((res: any) => {
        var url = window.URL.createObjectURL(res.data);
        var a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = res.filename;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove(); // remove the element
        // },
      },
        (err) => {
          this.toastr.error(this.translate.instant("Export failed"));
        });
  }

  public createDuplicate(zone: GeozoneViewModel) {
    this.zonesService.GetZone(zone.Id)
      .subscribe(zone => {
        let clone: GeozoneViewModel = Object.assign(new GeozoneViewModel(), zone);

        clone.Id = 0;
        clone.OwnerId = 0;
        clone.Objects = [];
        clone.GroupIds = [];
        //на всякий случай
        clone.Groups = [];

        this.editZone(clone);
      });
  }
}

